export default __webpack_public_path__ + "static/media/5D.03b1a4af.svg";